export default __webpack_public_path__ + "c2c8f30906b7d1b56eb0774b9b0873c2.png";